import {
    getOrganization,
    OrganizationEditionInput,
    updateOrganization,
} from '@wwf/sdk';
import type { DataProvider } from 'react-admin';
import { toRecord } from '../utils';

export const organizationProvider: Partial<DataProvider> = {
    getOne: async (_resource, _params) => {
        const org = await getOrganization();
        if (!org) throw new Error('Organization not found');
        return { data: toRecord(org) as any };
    },
    update: async (_resource, params) => {
        const org = await updateOrganization(
            params.data as OrganizationEditionInput
        );
        return { data: toRecord(org) as any };
    },
};
